import { component } from "picoapp";
import React, { Component, useState } from "react";
import ReactDOM from "react-dom";
import Flickity from "react-flickity-component";
import ReactPlayer from "react-player";
import { Waypoint } from "react-waypoint";

const Player = ({ video, playing, handleVideoEnd, isPaused }) => {
  const [isVisible, setIsVisible] = useState(false);
  // console.log(shouldPlay);

  return (
    <Waypoint
      scrollableAncestor={window}
      onEnter={({ previousPosition, currentPosition }) => {
        setIsVisible(true);
      }}
      onLeave={() => {
        setIsVisible(false);
      }}
    >
      <div className="slider-item">
        <div className="Player">
          <ReactPlayer
            className="media-player"
            url={video}
            playing={playing && isVisible && isPaused === false}
            onEnded={handleVideoEnd}
            width="100%"
            height="100%"
            config={{
              youtube: {
                playerVars: {
                  modestbranding: 1,
                  showinfo: 0,
                },
              },
              vimeo: {
                playerOptions: {
                  responsive: true,
                },
              },
            }}
          />
        </div>
      </div>
    </Waypoint>
  );
};

class VideoSlider extends Component {
  constructor(el) {
    super();
    this.state = {
      currentSlide: 0,
      videos: [
        "https://vimeo.com/261973524",
        "https://vimeo.com/261972934",
        "https://vimeo.com/261973513",
        "https://vimeo.com/261972911",
        "https://vimeo.com/261969958",
        "https://vimeo.com/261969950",
        "https://vimeo.com/261964509",
        "https://vimeo.com/261959849",
      ],
      isPaused: false,
    };
    this.handleVideoEnd = this.handleVideoEnd.bind(this);
  }

  componentDidMount() {
    this.flkty.on("settle", () => {
      this.setState({ currentSlide: this.flkty.selectedIndex });
    });
    this.flkty.on("staticClick", () => {
      this.setState({ ...this.state, isPaused: !this.state.isPaused });
    });
  }

  render() {
    const sliderOptions = {};

    return (
      <div>
        <Flickity options={sliderOptions} flickityRef={(c) => (this.flkty = c)}>
          {this.state.videos.map((video, index) => (
            <Player
              key={index}
              video={video}
              playing={index === this.state.currentSlide}
              handleVideoEnd={this.handleVideoEnd}
              isPaused={this.state.isPaused}
            />
          ))}
        </Flickity>
      </div>
    );
  }

  handleVideoEnd() {
    this.flkty.next();
  }
}

export default component((node, ctx) => {
  const element = <VideoSlider appstate={ctx} parentNode={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function() {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
